import React from 'react';

/** A hospital's own logo, shown beside the Anuvedana logo. Renders nothing when the hospital has no logo. */
const HospitalLogo = ({ logoUrl, name, size = 96, showName = false, stacked = false, style }) => {
  if (!logoUrl) return null;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: stacked ? 'column' : 'row',
        alignItems: 'center',
        gap: stacked ? '0.4rem' : '0.65rem',
        ...style
      }}
    >
      <span
        aria-hidden="true"
        style={stacked
          ? { height: 1, width: '60%', background: '#e2e8f0' }
          : { width: 1, alignSelf: 'stretch', background: '#e2e8f0' }}
      />
      <img
        src={logoUrl}
        alt={name ? `${name} logo` : 'Hospital logo'}
        title={name || undefined}
        style={{ width: size, height: size, objectFit: 'contain', borderRadius: 12, background: '#fff' }}
      />
      {showName && name && (
        <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#334155', maxWidth: 160, lineHeight: 1.3, textAlign: stacked ? 'center' : 'left' }}>
          {name}
        </span>
      )}
    </div>
  );
};

export default HospitalLogo;
